import { UserTokenType } from 'types/global';
import axiosRequest from './restapi';

export const getAllUsers = (userToken: UserTokenType, filter?: any) => {
  return axiosRequest(
    {
      method: 'get',
      url: `/admins/users${filter ? '?filter=' : ''}${filter ? JSON.stringify(filter) : ''}`,
    },
    userToken
  );
};

export const signInAdminAs = (email: string, userToken: UserTokenType) => {
  return axiosRequest(
    {
      method: 'post',
      url: '/admins/login-as',
      data: { email },
    },
    userToken
  );
};
